import * as CONST from '../const';
class CalculatorProjectModuleGeometry {
    project;
    moduleData;
    //in % of full size of project
    width;
    height;
    constructor(project, moduleData) {
        this.project = project;
        this.moduleData = moduleData;
        this.width = parseFloat(moduleData.width);
        this.height = parseFloat(moduleData.height);
    }
    getPaspartuWidth() {
        if (this.project.hasPaspartu()) {
            const value = this.project.getActivePropertyValue('paspartu');
            if (value) {
                return {
                    top: value.value.schema.top * value.value.width,
                    left: value.value.schema.left * value.value.width,
                    right: value.value.schema.right * value.value.width,
                    bottom: value.value.schema.bottom * value.value.width
                };
            }
        }
        return {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        };
    }
    getViewportOffset(dir) {
        return this.getPaspartuWidth()[dir] + this.getBagetWidth();
    }
    getInnerCompositeSize() {
        const canvas = this.getModuleRealSize(), passpartu = this.getPaspartuWidth(), bagetOverlapDelta = this.isBagetSet() ? CONST.BAGET_OVERLAP * 2 : 0;
        const result = {
            width: canvas.width - bagetOverlapDelta,
            height: canvas.height - bagetOverlapDelta,
        };
        if (!this.project.isWithPaspartuOverflow()) {
            result.width += (passpartu.left + passpartu.right);
            result.height += (passpartu.top + passpartu.bottom);
        }
        return result;
    }
    getBagetWidthInPercents() {
        const composite = this.getCompositeSize();
        return ((this.getBagetWidth() / composite.width) * 100);
    }
    getBagetHeightInPercents() {
        const composite = this.getCompositeSize();
        return (this.getBagetWidth() / composite.height) * 100;
    }
    /**
  * Returns size of visible part of canvas in percents of outer composite size
  **/
    getCanvasSizeInPercents() {
        const composite = this.getCompositeSize();
        const visibleCanvasSize = this.getVisibleCanvasSize();
        return {
            width: (visibleCanvasSize.width / composite.width) * 100,
            height: (visibleCanvasSize.height / composite.height) * 100
        };
    }
    /**
  * Returns size of visible part of canvas in cm
  **/
    getVisibleCanvasSize() {
        const canvas = this.getModuleRealSize(), paspartuWidth = this.getPaspartuWidth();
        const visibleCanvasSize = {
            width: canvas.width,
            height: canvas.height
        };
        if (this.project.isWithPaspartuOverflow()) {
            visibleCanvasSize.width -= (paspartuWidth.left + paspartuWidth.right);
            visibleCanvasSize.height -= (paspartuWidth.top + paspartuWidth.bottom);
        }
        return visibleCanvasSize;
    }
    getCanvasSizeInPercentsOfInner() {
        const composite = this.getInnerCompositeSize();
        const visibleCanvasSize = this.getVisibleCanvasSize();
        return {
            width: (visibleCanvasSize.width / composite.width) * 100,
            height: (visibleCanvasSize.height / composite.height) * 100
        };
    }
    getBagetWidth() {
        const baget = this.getBagetData();
        return baget ? (typeof baget.value.width === 'number' ? baget.value.width : parseFloat(baget.value.width)) : 0;
    }
    getBagetData() {
        return this.project.getActivePropertyValue('baget');
    }
    isBagetSet() {
        return this.getBagetData();
    }
    getProjectSize() {
        return this.project.getSize() ? this.project.getSize() : {
            width: CONST.DEFAULT_SIZE_WIDTH,
            height: CONST.DEFAULT_SIZE_HEIGHT
        };
    }
    getModuleRealWidth() {
        const projectSize = this.getProjectSize();
        return projectSize.width * this.width / 100;
    }
    getModuleRealHeight() {
        const projectSize = this.getProjectSize();
        return projectSize.height * this.height / 100;
    }
    getModuleRealSize() {
        return {
            width: this.getModuleRealWidth(),
            height: this.getModuleRealHeight()
        };
    }
    getCompositeSize() {
        const bagetWidth = this.getBagetWidth();
        const result = this.getInnerCompositeSize();
        result.width += 2 * bagetWidth;
        result.height += 2 * bagetWidth;
        return result;
    }
    getPerimeter() {
        const paspartu = this.getPaspartuWidth();
        if (this.project.isWithPaspartuOverflow()) {
            const { width, height } = this.getModuleRealSize();
            return (width + height) * 2;
        }
        else {
            const { width, height } = this.getInnerCompositeSize();
            return (width + paspartu.left + paspartu.right
                +
                    height + paspartu.top + paspartu.bottom) * 2;
        }
    }
    getSquare() {
        if (this.project.isWithPaspartuOverflow()) {
            const { width, height } = this.getModuleRealSize();
            return width * height;
        }
        else {
            const { width, height } = this.getInnerCompositeSize();
            return width * height;
        }
    }
}
export default CalculatorProjectModuleGeometry;
